var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login"},[_c('div',{staticClass:"Login-Section"},[_c('LoginHeader',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }